import { ScrollingModule } from '@angular/cdk/scrolling'
import { AsyncPipe } from '@angular/common'
import { Component, OnDestroy } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone'
import { TranslateService } from '@ngx-translate/core'
import { Subscription } from 'rxjs'

import { AlertComponent } from './shared/components/alert/alert.component'
import { DebuggingModalComponent } from './shared/components/debugging-modal/debugging-modal.component'
import { LoadingComponent } from './shared/components/loading/loading.component'
import { PlaceBetModalComponent } from './shared/components/place-bet-modal/place-bet-modal.component'
import { PlaceBetModalService } from './shared/components/place-bet-modal/place-bet-modal.service'
import { ToastComponent } from './shared/components/toast/toast.component'
import { SUPPORTED_LANGUAGES } from './shared/constants/common.constant'
import { HelperService } from './shared/services/helper.service'
import { ThemeService } from './shared/services/theme.service'

@Component({
	selector: 'app-root',
	templateUrl: 'app.component.html',
	standalone: true,
	imports: [
		AlertComponent,
		ToastComponent,
		IonApp,
		IonRouterOutlet,
		FormsModule,
		ScrollingModule,
		LoadingComponent,
		DebuggingModalComponent,
		AsyncPipe,
		PlaceBetModalComponent,
	],
})
export class AppComponent implements OnDestroy {
	private readonly subscriptions$: Subscription = new Subscription()

	constructor(
		private readonly translateService: TranslateService,
		private readonly helperService: HelperService,
		private readonly themeService: ThemeService,
		protected readonly placeBetModalService: PlaceBetModalService,
	) {
		this.translateService.addLangs(SUPPORTED_LANGUAGES.map((language) => language.symbol))
		this.translateService.setDefaultLang('en')
		this.translateService.use(this.helperService.getSelectedLanguage())
		this.themeService.initTheme()
	}

	ngOnDestroy(): void {
		this.subscriptions$.unsubscribe()
	}
}
